import { UseQueryOptions } from '@tanstack/react-query';
import useAppQuery from 'hooks/useAppQuery';
import {
  SystemTemplate,
  SystemTemplates,
} from 'models/automation/SystemTemplates';
import API from 'services/API';
import { SYSTEM_TEMPLATES_BASE_QUERY_KEY } from './useFetchSystemTemplates';

type ReactQueryOptions = Omit<
  UseQueryOptions<SystemTemplate>,
  'queryKey' | 'queryFn'
>;

type UseFetchSystemTemplateByKeyArgs = ReactQueryOptions & {
  key: SystemTemplates;
};

const useFetchSystemTemplateByKey = ({
  enabled = true,
  key,
  ...options
}: UseFetchSystemTemplateByKeyArgs) => {
  return useAppQuery<SystemTemplate>({
    queryKey: [SYSTEM_TEMPLATES_BASE_QUERY_KEY, 'detail', key],
    queryFn: async () => {
      const response = await API.get<SystemTemplate>(
        `/api/internal/automation/system-templates/${key}`,
      );

      return response.data;
    },
    enabled,
    staleTime: 30000,
    ...options,
  });
};

export default useFetchSystemTemplateByKey;
